import { z } from 'zod';

import { emailSchema, passwordSchema } from '@web/utils';

export const registerSchema = z
  .object({
    first_name: z
      .string({ error: 'First name is required' })
      .min(1, 'First name is required'),
    last_name: z
      .string({ error: 'Last name is required' })
      .min(1, 'Last name is required'),
    email: emailSchema,
    password: passwordSchema,
    confirm_password: passwordSchema,
    accepted_terms: z.boolean().optional(),
    invite_code: z.string().optional(),
  })
  .refine((values) => values.password === values.confirm_password, {
    path: ['confirm_password'],
    message: 'Passwords must match',
  })
  .refine((values) => Boolean(values.accepted_terms), {
    path: ['accepted_terms'],
    message: 'You must accept the terms to continue',
  });

export type RegisterSchema = z.infer<typeof registerSchema>;
